export type SessionStructureBlock =
  | { type: "text"; content: string }
  | { type: "table"; rows: Array<{ num: string; col1: string; col2: string; col3: string }> };

export type PhaseDetailsBlock =
  | { type: "text"; content: string }
  | {
      type: "table";
      rows: Array<{
        num: string;
        col1: string;
        col2: string;
        col3: string;
        col4: string;
      }>;
    };

/** Parse session structure plain text into blocks (text + table rows). Format: "1. Col1 --- Col2 --- Col3" */
export function parseSessionStructureBlocks(content: string): SessionStructureBlock[] {
  const blocks: SessionStructureBlock[] = [];
  const lines = content.split(/\r?\n/);
  let currentRows: Array<{ num: string; col1: string; col2: string; col3: string }> = [];
  let currentText: string[] = [];

  const flushText = () => {
    if (currentText.length) {
      blocks.push({ type: "text", content: currentText.join("\n") });
      currentText = [];
    }
  };
  const flushTable = () => {
    if (currentRows.length) {
      blocks.push({ type: "table", rows: [...currentRows] });
      currentRows = [];
    }
  };

  for (const line of lines) {
    const trimmed = line.trim();
    const match = trimmed.match(/^(\d+)\.\s*(.+?)\s+---\s+(.+?)\s+---\s+(.+)$/);
    if (match) {
      flushText();
      currentRows.push({
        num: match[1],
        col1: match[2].trim(),
        col2: match[3].trim(),
        col3: match[4].trim(),
      });
    } else {
      flushTable();
      if (trimmed || currentText.length > 0) currentText.push(line);
    }
  }
  flushText();
  flushTable();
  return blocks;
}

/**
 * Parse phase details plain text into blocks (text + 4-column table rows).
 * Format: "1. Session Block --- Exercise / Series --- Sets × Reps / Tempo / Rest --- Coaching Focus / Notes"
 */
export function parsePhaseDetailsBlocks(content: string): PhaseDetailsBlock[] {
  const blocks: PhaseDetailsBlock[] = [];
  const lines = content.split(/\r?\n/);
  let currentRows: Array<{
    num: string;
    col1: string;
    col2: string;
    col3: string;
    col4: string;
  }> = [];
  let currentText: string[] = [];

  const flushText = () => {
    if (currentText.length) {
      blocks.push({ type: "text", content: currentText.join("\n") });
      currentText = [];
    }
  };
  const flushTable = () => {
    if (currentRows.length) {
      blocks.push({ type: "table", rows: [...currentRows] });
      currentRows = [];
    }
  };

  for (const line of lines) {
    const trimmed = line.trim();
    const match = trimmed.match(
      /^(\d+)\.\s*(.*?)\s+---\s+(.*?)\s+---\s+(.*?)\s+---\s+(.*)$/
    );
    if (match) {
      flushText();
      currentRows.push({
        num: match[1],
        col1: match[2].trim(),
        col2: match[3].trim(),
        col3: match[4].trim(),
        col4: match[5].trim(),
      });
    } else {
      flushTable();
      if (trimmed || currentText.length > 0) currentText.push(line);
    }
  }
  flushText();
  flushTable();
  return blocks;
}
